import React from "react";

import StandardRubricEdit from "./components/StandardRubricEdit";
import StandardRubricView from "./components/StandardRubricView";

const StandardRubric = props => {
  const { mode = "edit", testId = "appComponents-standardRubric" } = props;

  switch (mode) {
    case "create":
    case "edit":
      return <StandardRubricEdit {...props} testId={testId} />;
    case "view":
      return <StandardRubricView {...props} testId={testId} />;
    default:
      return null;
  }
};

export default StandardRubric;
